import {
  Button,
  Group,
  LoadingOverlay,
  Paper,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useNavigate, useParams, useRouteLoaderData } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useEffect, useState } from "react";
import BackButton from "../../../../components/View/BackButton";
import { createTeam, editTeam } from "../../../../api/UserAPI";
import { notifications } from "@mantine/notifications";
import { getEmails } from "../../../../api/EmailAPI";
import { parseDate } from "../../../../functions/dates";
import { IconDeviceFloppy } from "@tabler/icons-react";

const TeamSettings = () => {
  const lang = useLanguage((s) => s.language);
  const { teamId } = useParams();
  const profile = useRouteLoaderData("team");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);

    setLoading(true);

    const main = teamId ? editTeam : createTeam;
    main({ id: parseInt(teamId), name: data.name })
      .then((response) => {
        notifications.show({
          message: teamId
            ? lang.teams.row_highlight.updated
            : lang.teams.row_highlight.created,
          color: "tertiary.8",
        });
        navigate("../?highlight=" + (response?.data?.team_id || profile?.id));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getEmails();
  }, []);

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit}
      pos={"relative"}
      gap={"lg"}
      mt={32}
    >
      <LoadingOverlay
        visible={loading}
        w={"100%"}
        h={"100%"}
        overlayProps={{
          blur: 2,
        }}
      />
      <Paper component={Group} p={"md"} gap={"xl"} px={"xl"}>
        <Text size="xl" fw={700}>
          {lang.teams.create.dialog.name}
        </Text>
        <TextInput
          name="name"
          defaultValue={profile?.name}
          required
          autoFocus
          size="lg"
          w={300}
        />

        {profile && (
          <Text ml={"auto"}>{lang.white_labels.created_on} {parseDate(profile.created_on)}</Text>
        )}
      </Paper>

      <Group
        justify="end"
        gap={"xl"}
        pos={"sticky"}
        bottom={0}
        p={"md"}
        bg={"#fff"}
        style={{ borderRadius: 12 }}
      >
        <BackButton />
        <Button
          type="submit"
          color="primary"
          size="md"
          leftSection={<IconDeviceFloppy />}
        >
          {profile ? lang.global.save : lang.teams.create.button_label}
        </Button>
      </Group>
    </Stack>
  );
};

export default TeamSettings;
